var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.41192 3.4724C8.41192 2.81474 8.41192 2.48591 8.30466 2.22694C8.23374 2.0556 8.12974 1.89991 7.99861 1.76878C7.86748 1.63765 7.71179 1.53365 7.54045 1.46273C7.28148 1.35547 6.95265 1.35547 6.29498 1.35547H4.17805C2.8472 1.35547 2.18248 1.35547 1.76898 1.76898C1.35547 2.18248 1.35547 2.8472 1.35547 4.17805V6.29498C1.35547 6.95265 1.35547 7.28148 1.46273 7.54045C1.53365 7.71179 1.63765 7.86748 1.76878 7.99861C1.89991 8.12974 2.0556 8.23374 2.22694 8.30466C2.48591 8.41192 2.81474 8.41192 3.4724 8.41192",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.235 5.58984H7.00113C6.2217 5.58984 5.58984 6.2217 5.58984 7.00113V11.235C5.58984 12.0144 6.2217 12.6463 7.00113 12.6463H11.235C12.0144 12.6463 12.6463 12.0144 12.6463 11.235V7.00113C12.6463 6.2217 12.0144 5.58984 11.235 5.58984Z",
    stroke: "white",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2051"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.3a24891b1dd2e820a64c24473d38faba.svg";
export { ForwardRef as ReactComponent };